// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3c9cg","buttons":"PendingPaymentAlert_buttons__2ZsQV"};